import { FilterResultPreset } from "../components/FilterResultHeader/FilterResultHeader";
import { ClientSettingsFilterResults } from "../model/reference/settingsTypes";

export function applyFilterPreset(
  filterResults: ClientSettingsFilterResults[],
  filterResultPresets: FilterResultPreset[],
  presetName: string,
): ClientSettingsFilterResults[] {
  const selectedPreset = filterResultPresets.find((p) => p.name === presetName);
  if (!selectedPreset) return filterResults;

  const matchSet = new Set(
    selectedPreset.filterResultPresetOptions.map(
      (opt) => `${opt.filterResultId}-${opt.infoId}-${opt.optionId}`,
    ),
  );

  return filterResults.map((fr) => ({
    ...fr,
    info: fr.info.map((infoItem) => {
      const directMatch = matchSet.has(`${fr.id}-${infoItem.id}-0`);
      const matchingOption = infoItem.options?.find((opt) =>
        matchSet.has(`${fr.id}-${infoItem.id}-${opt.id}`),
      );
      const isSet = Boolean(directMatch || matchingOption);

      return {
        ...infoItem,
        isSet,
        value: matchingOption
          ? matchingOption.value
          : infoItem.options?.length && !isSet
            ? ""
            : infoItem.value,
      };
    }),
  }));
}
